// @flow

/**
 * @enum {number}
 */
const BrowserType = {
  OTHER: 0,
  CHROME: 1,
  SAFARI: 2,
  IE: 3,
  FIREFOX: 4,
  OPERA: 5,
};

// determines if Intersection Observer v2 exists on the current browser.
// See https://developers.google.com/web/updates/2019/02/intersectionobserver-v2
export const doesIOv2Exist = () => {
  const observer = new IntersectionObserver(() => null, {
    threshold: [1.0],
    trackVisibility: true,
    delay: 100,
  });

  // if IOv2 exists, the resulting object will have a field trackVisibility
  // $FlowFixMe - trackVisibility is not yet in the IntersectionObserver flow type
  return !!observer.trackVisibility;
};

export default BrowserType;
